// extracted by mini-css-extract-plugin
module.exports = {"amazon-sale-F":"F_amazon-sale-F__IF9dg"};